<template>
  <div class="TradeManagement">
    <div class="navbar">
      <NavBar></NavBar>
    </div>
    <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop"></PlainSideBar>
    </div>

    <div v-if="isDesktop">
      <div class="cover-page-container">
        <div class="flex-space-between user-details-section">
          <div class="label-lg-black-bold">
            <span class="crown-outer">
              <img src="../assets/images/Active RA - Crown Icon.svg" alt="" />
            </span>
            Trade Details
          </div>

          <div>
            <div class="flex" style="margin-top: 7px; align-items: baseline; justify-content: end;">
              <el-button class="download-btn export-btn flex" style="" :loading="is_export_Loading"
                @click="getTotalTradeEntriesForExport()">
                <span style="position: relative; top: -2px;">
                  Export
                  <i class="el-icon-document"
                    style="font-size: 20px; margin-left: 3px; position: relative; top: 2px;"></i>
                </span>
              </el-button>
            </div>
          </div>
        </div>

        <div class="filter-section">
          <el-row :gutter="15" style="align-items: center;">
            <div class="flex-space-between">
              <div class="flex" style="flex-wrap: wrap; gap: 10px;">
                <!-- Stock Search -->
                <!-- <div>
          <div class="input-label-bold-gray">Filter By:</div>
          <el-input
            v-model="searchQuery"
            size="mini"
            placeholder="Stock"
            clearable
            style="width: 200px; margin-right: 18px;"
            @input="filterTradeData"
          />
        </div> -->

                <!-- Past Duration -->
                <div style="margin-right: 20px;">
                  <div class="input-label-bold-gray">Past Duration:</div>
                  <div class="flex">
                    <el-date-picker v-model="startDate" type="date" placeholder="Start Date"
                      style="width: 130px; margin-right: 18px;" size="mini" class="custom-date-picker"
                      :default-value="defaultStartDate" :picker-options="startDatePickerOptions"
                      @change="handleStartDateChange"></el-date-picker>
                    <el-date-picker v-model="endDate" type="date" placeholder="End Date" style="width: 130px;"
                      size="mini" class="custom-date-picker" :default-value="defaultEndDate"
                      :picker-options="endDatePickerOptions" @change="handleEndDateChange"></el-date-picker>
                  </div>
                </div>

                <!-- Username Filter -->
                <div>
                  <div class="input-label-bold-gray">Username:</div>
                  <el-input v-model="filterUserName" size="mini" placeholder="Username" clearable
                    style="width: 180px; margin-right: 10px;" @input="triggerTradeFilter" />
                </div>

                <!-- Stock Name Filter -->
                <div>
                  <div class="input-label-bold-gray">Stock Name:</div>
                  <el-input v-model="filterStockName" size="mini" placeholder="Stock Name" clearable
                    style="width: 180px; margin-right: 10px;" @input="triggerTradeFilter" />
                </div>

                <!-- Segment Filter -->
                <div>
                  <div class="input-label-bold-gray">Segment:</div>
                  <el-select v-model="filterSegment" size="mini" placeholder="Segment" clearable
                    style="width: 90px; margin-right: 10px;" @change="triggerTradeFilter">
                    <el-option label="Equity" value="equity" />
                    <el-option label="Options" value="options" />
                  </el-select>
                </div>

                <!-- Reset Button -->
                <div style="margin-top: 30px; border-radius: 10px;">
                  <el-button size="mini" @click="clearFilters"
                    style="border-radius: 10px; padding: 3px 10px; color: rgb(64, 158, 255); border-color: rgb(64, 158, 255);"
                    :disabled="!isFilterActive()">
                    Reset
                  </el-button>
                </div>
              </div>
            </div>
          </el-row>
        </div>

        <div v-if="tradedStocksList.length || is_trade_list_loading" v-loading="is_trade_list_loading">
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th style="min-width: 100px; white-space: normal; text-align: left !important;">Name </th>
                  <th style="min-width: 100px; white-space: normal;">Customer ID </th>
                  <th style="min-width: 100px; white-space: normal;">Quantity </th>
                  <th style="min-width: 160px; white-space: normal;">Recommended By </th>
                  <th style="min-width: 110px; white-space: normal;">Segment </th>
                  <!-- <th style="min-width: 70px; white-space: normal;">Stoploss </th>
                  <th style="min-width: 80px; white-space: normal;">Target Price</th> -->
                  <th style="min-width: 120px; white-space: normal;">Transaction Type </th>
                  <th style="min-width: 100px; white-space: normal;">Product Type </th>
                  <th style="min-width: 100px; white-space: normal;">Order Type </th>
                  <th style="min-width: 125px; white-space: normal;">Trade time </th>
                  <th style="min-width: 100px; white-space: normal;">Order Value </th>
                  <th style="min-width: 100px; white-space: normal;">Stock/Indice </th>
                  <th style="min-width: 100px; white-space: normal;">Order Status</th>
                </tr>

              </thead>
              <tbody>
                <tr v-for="(data, index) in tradedStocksList" :key="index">
                  <td style="text-align: left !important;">{{ data.user_name ? data.user_name : '-' }}</td>
                  <td>{{ data.customer_id ? data.customer_id : '-' }}</td>
                  <td>{{ data.quantity ? data.quantity : 0 }}</td>
                  <td>{{ data.traded_on_reco_expert_name ? data.traded_on_reco_expert_name : '-' }}</td>
                  <td class="capitalize">{{ data.order_segment ? data.order_segment : '-' }}</td>
                  <!-- <td>{{ data.stop_loss ? data.stop_loss : '' }}</td>
                  <td>{{ data.target_price ? data.target_price : '' }}</td> -->
                  <td>{{ data.transaction_type ? data.transaction_type : '' }}</td>
                  <td>{{ data.product_type ? data.product_type : '' }}</td>
                  <td>{{ data.order_type ? data.order_type : '' }}</td>
                  <td> {{ data.trade_time ? moment(data.trade_time, "DD-MM-YYYY HH:mm:ss").format("MMM DD YYYY, h:mmA")
                    : '-' }}</td>
                  <td>{{ data.order_value ? data.order_value : 0 }}</td>
                  <td>{{ data.stock_name ? data.stock_name : '' }}</td>
                  <td>{{ data.status ? data.status : '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pagination" style="text-align:center">
            <el-pagination @current-change="handleCurrentChange" :current-page="pagination.current_page"
              :page-sizes="[5, 10, 20, 50]" :page-size="pagination.page_size" :total="pagination.total_entries"
              :pager-count="5" layout="total, prev, pager, next"></el-pagination>
          </div>
        </div>
        <div v-if="!is_trade_list_loading && !tradedStocksList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="cover-page-container">
        <div class="block-mob-view">
          To access the Dashboard Analytics, please log in via desktop for an
          enhanced user experience.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import PlainSideBar from "@/components/PlainSideBar.vue";
import Hexagon from "@/components/Hexagon.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import NoDataFound from "@/components/NoDataFound.vue";
import NavBar from "@/components/NavBar.vue";
import ExcelJS from "exceljs";

export default {
  name: "TradeManagement",

  mixins: [filterCallBack, screenSize, HelperNetworkCallBack],

  components: {
    PlainSideBar,
    Hexagon,
    NavBar,
    NoDataFound,
  },

  data() {
    return {
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      moment: moment,
      currentPage: 1,
      is_export_Loading: false,
      searchQuery: '',
      is_trade_list_loading: false,
      tradedStocksList: [
      ],
      pagination: {},
      brokerList: [],
      client_id: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      startDate: "", // no preselected date
      endDate: "", // no preselected date
      defaultStartDate: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ), // default view of the previous month
      defaultEndDate: new Date(),
      filterUserName: '',
      filterStockName: '',
      // filterSegment: [],
      filterSegment: "",
    };
  },

  validations: {
    review: {
      required,
    },
  },

  mounted() {
    // this.getTradeList();
     this.getBrokerList();
  },
  watch: {
    startDate(newValue, oldValue) {
      if (newValue) {
        this.startDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.startDate = "";
      }
    },
    endDate(newValue, oldValue) {
      if (newValue) {
        this.endDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.endDate = "";
      }
    },
  },

  methods: {
    getBrokerList() {
  serverAddr
    .get("/auth/admin/v1/client_list")
    .then((response) => {
      if (response.data.status) {
        this.brokerList = response.data.data;

        if (this.brokerList.length > 0) {
          this.client_id = this.brokerList[0].id;
          this.getTradeList();
        }
      }
    })
    .catch(
      function(error) {
        console.log(error);
        this.is_user_list_loading = false;
      }.bind(this)
    );
},
    triggerTradeFilter() {
      this.currentPage = 1;
      this.getTradeList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTradeList();
    },
    filterTradeData() {

    },
    isFilterActive() {
    },
    clearFilters() {
      this.searchQuery = "";
      this.startDate = "";
      this.endDate = "";
      this.filterUserName = "";
      this.filterStockName = "";
      this.filterSegment = [];
      this.getTradeList();

    },
    getTradeList() {
      this.is_trade_list_loading = true;
      serverAddr
        .post("/auth/admin/v1/broker_trading_dashboard", {
          page_no: this.currentPage,
          page_per_entries: this.pagination.page_size ? this.pagination.page_size : 10,
          client_id: this.client_id,
          start_date: this.startDate,
          end_date: this.endDate,
          full_name: this.filterUserName,
          stock_name: this.filterStockName,
          segments: this.filterSegment ? [this.filterSegment] : [],
          client_id: this.selected_broker.id
        })
        .then((response) => {
          if (response.data.status) {
            this.tradedStocksList = response.data.data;
            this.pagination = {
              total_entries: response.data.pagination.total_entries || 0,
              current_page: response.data.pagination.current_page || 1,
              page_size: response.data.pagination.page_size || 10,
            };
          }
          this.is_trade_list_loading = false;
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_trade_list_loading = false;
          }.bind(this)
        );
    },

    getTotalTradeEntriesForExport() {
      this.is_export_Loading = true;

      const obj = {
        page_no: this.currentPage,
        page_per_entries: this.pagination.page_size ? this.pagination.page_size : 10,
        client_id: this.selected_broker.id,
        is_export: false,
        q: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        full_name: this.filterUserName,
        stock_name: this.filterStockName,
        segments: this.filterSegment ? [this.filterSegment] : [],
      };

      serverAddr
        .post("/auth/admin/v1/broker_trading_dashboard", obj)
        .then((response) => {
          if (response.data.status) {
            this.exportTradeList = response.data.data;
            this.downloadTradeExcel();
          } else {
            this.is_export_Loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_export_Loading = false;
        });
    },

    async downloadTradeExcel() {
      try {
        const fieldsToRemove = []; // Add unwanted fields if needed later

        const newData = this.exportTradeList.map((obj) => {
          const newObj = { ...obj };
          fieldsToRemove.forEach((field) => delete newObj[field]);
          return newObj;
        });

        const data = newData;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Trade Details");

        // Define headers and their corresponding keys
        const headers = [
          { header: "Name", key: "user_name" },
          { header: "Customer ID", key: "customer_id" },
          { header: "Quantity", key: "quantity" },
          { header: "Recommended By", key: "traded_on_reco_expert_name" },
          { header: "Segment", key: "order_segment" },
          { header: "Transaction Type", key: "transaction_type" },
          { header: "Product Type", key: "product_type" },
          { header: "Order Type", key: "order_type" },
          { header: "Trade Time", key: "trade_time" },
          { header: "Order Value", key: "order_value" },
          { header: "Stock/Indice", key: "stock_name" },
          { header: "Order Status", key: "status" }, 
        ];

        worksheet.columns = headers.map((col) => ({
          header: col.header,
          key: col.key,
          width: 20,
        }));

        // Format and add rows
        data.forEach((item) => {
          worksheet.addRow({
            ...item,
            trade_time: item.trade_time
              ? moment(item.trade_time, "DD-MM-YYYY HH:mm:ss").format("MMM DD YYYY, h:mmA")
              : "-",
          });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "StockAnts Trade Details.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
      }

      setTimeout(() => {
        this.is_export_Loading = false;
      }, 100);
    },
    handleStartDateChange(val) {
      if (this.endDate && new Date(val) > new Date(this.endDate)) {
        this.endDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getTradeList();
      }
    },
    handleEndDateChange(val) {
      if (
        val != null &&
        this.startDate &&
        new Date(val) < new Date(this.startDate)
      ) {
        this.startDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getTradeList();
      }
    },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return user details e.g. accuracy, success rate, rating etc.
    user_details() {
      return this.$store.state.user_details;
    },

    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.endDate) {
            return (
              time.getTime() > now.getTime() ||
              time.getTime() > new Date(this.endDate).getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.startDate) {
            return (
              time.getTime() < new Date(this.startDate).getTime() ||
              time.getTime() > now.getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    selected_broker() {
      return this.$store.state.selected_broker
        ? this.$store.state.selected_broker
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.TradeManagement {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .block-mob-view {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: $secondary-theme-color;
    font-weight: 600;
    padding: 20px;
    text-align: center;
  }

  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }

  .marquee-container img {
    max-height: 35px;
    margin-right: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // Below css for Marquee tag
  marquee {
    height: 100px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
  }

  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  .cover-page-container {
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }

    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: 370px;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }

      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }

      .sub-section {
        padding: 0 !important;
      }

      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }

    .center-content {
      text-align: center;
      vertical-align: middle;
    }

    .loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }

    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }

      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }

      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }

      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 15px;
            white-space: nowrap;
            vertical-align: middle;
            text-align: center;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }

      tbody {

        // min-height: 300px;
        tr {

          //  cursor: pointer;
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 10px 15px;
            text-align: center;
            // vertical-align: unset;
          }
        }

        // tr:hover {
        //   background-color: #eff5fe;
        // }

        tr:nth-child(even) td {
          background-color: #f1f7f8;
          /* Set background color for even rows */
        }
      }

      td.fixed-column,
      th.fixed-column {
        position: sticky;
        right: -1px;
        /* Fix column to the right */
        z-index: 1;
        background-color: #ffff;
        border-bottom: none;
        height: 23px;
        border-left: 1px solid #dcdcdc !important;
        box-shadow: -4px 1px 5px -3px #00000080;
        margin: 0;
        padding: 12px 8px;
      }
    }

    .el-range-editor.el-input__inner {
      margin-right: 20px;
    }

    .pagination {
      margin: 15px 0 10px;
    }

    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }

    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }

  .cover-page-container {
    width: calc(100% - 295px);
    margin-left: 280px;
    margin-top: 15px;
    padding-bottom: 10px;
    // padding: 20px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #dcd6d6;
    margin-bottom: 50px;
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {

    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 160px);
      margin-top: 15px;
    }

    .cover-page-container {
      //   padding: 20px 10px 0 10px;
    }

    .sideBarSection {
      display: none;
    }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.TradeManagement {
  .NoDataFound {
    padding: 15px 0 0 0;
  }

  .review-card {
    border-radius: 10px;

    .el-card__body {
      padding: 5px 20px;
    }
  }

  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}

.context-menu {
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 5;
}

.context-menu li {
  padding: 8px 12px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.context-menu li.inactive {
  color: #ccc;
  cursor: not-allowed;
}
</style>
